import React, { useEffect, useState, useCallback } from 'react';
import { Button, Form, Input, message, Radio } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  getSourceMapping, // Use a new or different API
  updateSourceConfigURLMapping, // This is your new save API
} from 'api/nach'; // Assuming these APIs exist
import { NACH_ROUTE } from 'features/nach/routes';

// Define the types for the data we'll be working with
type SourceUrlMappingPayload = {
  sourceConfigId?: number;
  sourceId?: string;
  configURL?: string;
  isActive?: boolean;
};

// const { Option } = Select;

const UpdateWebhookConfig: React.FC = () => {
  const [form] = Form.useForm<SourceUrlMappingPayload>();
  const navigate = useNavigate();
  const location = useLocation();
  const state: any = location.state;

  const [isSaving, setIsSaving] = useState(false);
  const [sourceUrlData, setSourceUrlData] = useState<SourceUrlMappingPayload>();

  useEffect(() => {
    // Fetch source URL mappings from an API
    // This is a placeholder; replace with your actual API call.

    getSourceMapping({ sourceId: state.sourceId })
      .then((res: any) => {
        console.log('source getSourceUrlMapping', res);
        if (res && res?.data) {
          setSourceUrlData(res.data);
          const state = res.data;
          form.setFieldsValue({
            sourceId: state.sourceId,
            configURL: state.configURL,
            isActive: state.active,
          });
        }
      })
      .catch((err) => {
        console.error('Failed to fetch source URL data:', err);
        message.error('Failed to load source URL data.');
      });

    // Set initial form values from state passed via react-router-dom
    // if (state) {
    //   form.setFieldsValue({
    //     sourceConfigId: state.SourceConfigId,
    //     sourceId: state.SourceId,
    //     configURL: state.ConfigURL,
    //     isActive: state.IsActive,
    //   });
    // }
  }, [form]);

  const handleSubmit = useCallback(
    async (values: SourceUrlMappingPayload) => {
      debugger;
      setIsSaving(true);
      try {
        const payload: SourceUrlMappingPayload = {
          sourceConfigId: values.sourceConfigId,
          sourceId: values.sourceId,
          configURL: values.configURL,
          isActive: values.isActive,
        };

        // Call the new save API
        await updateSourceConfigURLMapping(payload);

        message.success('Webhook configuration updated successfully!');
        form.resetFields();
        navigate(NACH_ROUTE.webhook_nach_master.to); // Redirect to a new route after success
      } catch (error) {
        console.error('Update failed:', error);
        message.error('Failed to update webhook configuration. Please try again.');
      } finally {
        setIsSaving(false);
      }
    },
    [navigate]
  );

  return (
    <div className="container">
      <div className="mid-container">
        <div className="submission-box">
          <h2>Edit Webhook Configuration</h2>
          <Form
            form={form}
            onFinish={handleSubmit}
            layout="vertical"
            scrollToFirstError
            className="standard-forms"
          >
            <div className="row">
              {/* <div className="col-xs-12 col-sm-6 col-md-6">
                <div className="input-box">
                  <Form.Item
                    label="Source Config ID"
                    name="sourceConfigId"
                    rules={[{ required: true, message: 'Please select a Source Config ID' }]}
                  >
                    <Input defaultValue={sourceUrlData?.sourceConfigId}></Input>
                    <Select placeholder="Select Source Config ID" size="large">
                      {sourceUrlData.map((data) => (
                        <Option key={data.sourceConfigId} value={data.sourceConfigId}>
                          {data.sourceConfigId}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div> */}

              {/* SourceID */}
              <div className="col-xs-12 col-sm-6 col-md-6">
                <div className="input-box">
                  <Form.Item
                    label="Source ID"
                    name="sourceId"
                    rules={[{ required: true, message: 'Please enter Source ID' }]}
                  >
                    <Input
                      defaultValue={sourceUrlData?.sourceId}
                      placeholder="Enter Source ID"
                      size="large"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>

            {/* ConfigURL */}
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12">
                <div className="input-box">
                  <Form.Item
                    label="Config URL"
                    name="configURL"
                    rules={[{ required: true, message: 'Please enter Config URL' }]}
                  >
                    <Input
                      defaultValue={sourceUrlData?.configURL}
                      placeholder="Enter Config URL"
                      size="large"
                    />
                  </Form.Item>
                </div>
              </div>
            </div>

            {/* Active/Inactive Buttons */}
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12">
                <Form.Item label="Status" name="isActive">
                  <Radio.Group defaultValue={sourceUrlData?.isActive}>
                    <Radio value={true}>Active</Radio>
                    <Radio value={false}>Inactive</Radio>
                  </Radio.Group>
                </Form.Item>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="payment-button">
              <Button type="primary" htmlType="submit" disabled={isSaving} loading={isSaving}>
                SAVE
              </Button>
              <Button
                style={{ marginLeft: '10px' }}
                onClick={() => navigate(NACH_ROUTE.webhook_nach_master.to)}
              >
                CANCEL
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default UpdateWebhookConfig;
